import _styled from "@emotion/styled-base";

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

import CheckCircleIcon from '@atlaskit/icon/glyph/check-circle';
import { G400 } from '@atlaskit/theme/colors';
import React from 'react';
/* CSS transform added because icon is not centered by default*/

var CheckCircleIconContainer = _styled("div", {
  target: "erb7cqj0",
  label: "CheckCircleIconContainer"
})(process.env.NODE_ENV === "production" ? {
  name: "1mzw1zc",
  styles: "display:flex;height:20px;"
} : {
  name: "1mzw1zc",
  styles: "display:flex;height:20px;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9jb21wb25lbnRzL0NoZWNrQ2lyY2xlSWNvbkdyZWVuLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQVEyQyIsImZpbGUiOiIuLi8uLi9zcmMvY29tcG9uZW50cy9DaGVja0NpcmNsZUljb25HcmVlbi5qcyIsInNvdXJjZXNDb250ZW50IjpbIi8vIEBmbG93XG5cbmltcG9ydCBDaGVja0NpcmNsZUljb24gZnJvbSAnQGF0bGFza2l0L2ljb24vZ2x5cGgvY2hlY2stY2lyY2xlJztcbmltcG9ydCB7IEc0MDAgfSBmcm9tICdAYXRsYXNraXQvdGhlbWUvY29sb3JzJztcbmltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJztcbmltcG9ydCBSZWFjdCBmcm9tICdyZWFjdCc7XG5cbi8qIENTUyB0cmFuc2Zvcm0gYWRkZWQgYmVjYXVzZSBpY29uIGlzIG5vdCBjZW50ZXJlZCBieSBkZWZhdWx0Ki9cbmNvbnN0IENoZWNrQ2lyY2xlSWNvbkNvbnRhaW5lciA9IHN0eWxlZC5kaXZgXG4gIGRpc3BsYXk6IGZsZXg7XG4gIGhlaWdodDogMjBweDtcbmA7XG5cbmV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIENoZWNrQ2lyY2xlSWNvbkdyZWVuKCkge1xuICByZXR1cm4gKFxuICAgIDxDaGVja0NpcmNsZUljb25Db250YWluZXI+XG4gICAgICA8Q2hlY2tDaXJjbGVJY29uIHByaW1hcnlDb2xvcj17RzQwMH0gLz5cbiAgICA8L0NoZWNrQ2lyY2xlSWNvbkNvbnRhaW5lcj5cbiAgKTtcbn1cbiJdfQ== */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});

export default function CheckCircleIconGreen() {
  return /*#__PURE__*/React.createElement(CheckCircleIconContainer, null, /*#__PURE__*/React.createElement(CheckCircleIcon, {
    primaryColor: G400
  }));
}